import moment from "moment";
// import { logoutUser } from "../store/actions/login.actions";
import agent from "../services/agent";
import { USER_LOGOUT } from "../store/constants/login.constants";


export const setTokenDetails = (authData) => {//eslint-disable-next-line
  const { access_token, expires_in, token_type, id_token, refresh_token } = authData;
  const expires = moment().unix() + expires_in;
  localStorage.setItem('accessToken', access_token);
  localStorage.setItem('expiresInSec', expires);
  localStorage.setItem('token_type', token_type);
  localStorage.setItem('refresh_token', refresh_token)
  localStorage.setItem('id_token', id_token);
};

export const getToken = (dispatch?: Function): any => {
  const access_token = localStorage.getItem("id_token");//cdc email claim not available in accessToken
  //  sessionStorage.getItem("token");
  const expires_in = localStorage.getItem("expiresInSec");
  // sessionStorage.getItem("expires_in");
  const refresh_token = localStorage.getItem('refresh_token');

  return new Promise((resolve) => {
    // check the difference between now and expired time for current token
    const diff = moment.unix(Number(expires_in)).diff(moment(), "minutes");

    if (access_token && diff > 5) {
      resolve(access_token);
    }
    else {
      agent.Auth.getRefreshToken(refresh_token).then((authData) => {
        setTokenDetails(authData);
        resolve(localStorage.getItem('id_token')); // resolve - id_token
      }).catch((err) => {
        resolve(err)
        dispatch && dispatch({ type: USER_LOGOUT });

      })
      // console.log("getToken ", diff);
      // dispatch && dispatch(logoutUser("TokenExpired"));
      // resolve(access_token);
    }
  });
};

export const modifyRolesList = (roles: any) => {
  const roleItems = [];
  roles.forEach((role) => {
    const { roleDisplayName, roleId } = role;
    roleItems.push({
      label: roleDisplayName,
      value: roleId,
      roleDisplayName: roleDisplayName,
      roleId: roleId,
    });
  });
  return roleItems;
};

function fixDecimalPlaces(value, decimalPlace = 2) {
  if (value !== "-") return parseFloat(value).toFixed(decimalPlace);
  else return value;
}

const unitLabelEnum = [
  {
    label: "flow",
    count: 6,
    index: 0
  },
  {
    label: "density",
    count: 5,
    index: 1
  },
  {
    label: "pressure",
    count: 5,
    index: 2
  },
  {
    label: "length",
    count: 5,
    index: 3
  },
  {
    label: "mass",
    count: 4,
    index: 4
  },
  {
    label: "area",
    count: 5,
    index: 5
  },
  {
    label: "temperature",
    count: 3,
    index: 6
  },
  {
    label: "viscosity",
    count: 6,
    index: 7
  },
  {
    label: "power",
    count: 5,
    index: 8
  },
  {
    label: "volume",
    count: 6,
    index: 9
  },
  {
    label: "dynamicviscosity",
    count: 6,
    index: 10
  }
];

export const solveEquation = (a, b, c) => {
  
  let solveEquation = 0;
  let delta, temp1, temp2, x1, x2;

  // Calculate DELTA
  temp1 = Math.pow(b, 2);
  temp2 = 4 * a * c;
  delta = temp1 - temp2;
  
  if (delta < 0) {
    delta = 0;
  }

  // Calculate first result of the equation:
  temp1 = 0;
  temp2 = 0;
  temp1 = -b + Math.pow(delta, 0.5);
  temp2 = 2 * a;
  x1 = temp1 / temp2;

  // Calculate second result of the equation:
  temp1 = 0;
  temp2 = 0;
  temp1 = -b - Math.pow(delta, 0.5);
  temp2 = 2 * a;
  x2 = temp1 / temp2;

  if (x1 === x2) {
    return x1;
  }

  if (x1 < 0 || x1 === 0) {
    if (x2 > 0) {
      solveEquation = x2;
    }
  } 
  else if (x2 < 0 || x2 === 0) {
      solveEquation = x1;
  }
  
  return solveEquation;
};

export const equivalentUnitValues = (unitLabel, unitIndex) => {
  
  var mult1, mult2, add1, add2;
  let unitValues = {mult1, mult2, add1, add2};
  let g = 9.80665;  //This value is not Declared in Caps old VB code. So, it is taken from HI3 for temporarily. Acceleration due to gravity(g) = 9.80665

  const { index } = unitLabelEnum.find(
    (item) => item.label === unitLabel
  );

  switch(index)
  {
    case 0: //flow
      {
        switch(unitIndex)
        {
          case 0: // m^3/h
            {
              unitValues.mult1 = 0.0002777777777;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 1: // m^3/s
            {
              unitValues.mult1 = 1;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 2: // l/min
            {
              unitValues.mult1 = 0.0000166666666;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 3: // l/s
            {
              unitValues.mult1 = 0.001;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 4: // UKgal/min
            {
              unitValues.mult1 = 0.000075776;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 5: // USgal/min
            {
              unitValues.mult1 = 0.0000630971;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
        }
        break;
      }
    case 1: //density
      {
        switch(unitIndex)
        {
          case 0: // kg/m^3
            {
              unitValues.mult1 = 1;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 1: // kg/l
            {
              unitValues.mult1 = 1000;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 2: // lb/ft^3
            {
              unitValues.mult1 = 16.01842;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 3: // lb/in^3
            {
              unitValues.mult1 = 27680;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 4: // °Baumé
            {
              unitValues.mult1 = 0;
              unitValues.mult2 = -145000;
              unitValues.add1 = 0;
              unitValues.add2 = -145;
              break;
            }
        }
        break;
      }
    case 2: //pressure
      {
        switch (unitIndex) 
        {
          
          case 0: // bar
            {
              unitValues.mult1 = 100000;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 1: // Pa(N/m2)
            {
              unitValues.mult1 = 1;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 2: // psi
            {
              unitValues.mult1 = 6894.76;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 3: //Torr(mmHg)
            {
              unitValues.mult1 = 133.33;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 4: // mWK
            {
              unitValues.mult1 = g * 1000;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
        }
        break;
      }
    case 3 :  //length
      {
        switch (unitIndex) 
        {
          case 0: // m
            {
              unitValues.mult1 = 1;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 1: // mm
            {
              unitValues.mult1 = 0.001;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 2: // ft
            {
              unitValues.mult1 = 0.3048;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 3: // in
            {
              unitValues.mult1 = 0.0254;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 4: // µ in
            {
              unitValues.mult1 = 0.0000254;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
        }
        break;
      }
    case 4 :  //mass
      {
        switch (unitIndex) 
        {
          case 0: // kg
            {
              unitValues.mult1 = 1;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 1: //lb
            {
              unitValues.mult1 = 0.45359;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 2: // ounce(oz)
            {
              unitValues.mult1 = 0.02835;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 3: // ton (UK)
            {
              unitValues.mult1 = 1016.1;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
        }
        break;
      }
    case 5 :  //area
      {
        switch (unitIndex) 
        {
          case 0: // m^2
            {
              unitValues.mult1 = 1;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 1: // mm^2
            {
              unitValues.mult1 = 0.000001;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 2: // ft^2
            {
              unitValues.mult1 = 0.092903;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 3: // in^2
            {
              unitValues.mult1 = 0.000645159;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 4: // yd^2
            {
              unitValues.mult1 = 0.83613;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
        }
        break;
      }
    case 6 :  //temperature
      {
        switch (unitIndex) 
        {
          case 0: // °C
            {
              unitValues.mult1 = 1;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 1: // °K
            {
              unitValues.mult1 = 1;
              unitValues.mult2 = 0;
              unitValues.add1 = -273.15;
              unitValues.add2 = -273.15;
              break;
            }
          case 2: // °F
            {
              // "5/9" is replaced with "0.55555555555555555555555555555556" because of value miscalculation in C#
              unitValues.mult1 = 0.55555555555555555555555555555556;
              unitValues.mult2 = 0;
              unitValues.add1 = -32 * 0.55555555555555555555555555555556;
              unitValues.add2 = -32 * 0.55555555555555555555555555555556;
              break;
            }
        }
        break;
      }
    case 7 :  //viscosity
      {
        switch(unitIndex)
        {
          case 0: // mPas or Cps (cP)
            {
              unitValues.mult1 = 0.001;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 1: // m^2/s
            {
              unitValues.mult1 = 1;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 2: // cSt
            {
              unitValues.mult1 = 0.000001;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 3: // Second Saybolt Universal (SSU) - Saybolt
            {
              unitValues.mult1 = 0.00000021867;
              unitValues.mult2 = -0.00016586;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 4: // Seconds Redwood - Redwood
            {
              unitValues.mult1 = 0.00000024965;
              unitValues.mult2 = -0.00015399;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 5: // °Engler
            {
              unitValues.mult1 = 0.0000077008;
              unitValues.mult2 = -0.0000073453;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
        }
        break;
      }
    case 8 :  //power
      {
        switch(unitIndex)
        {
          case 0: // kW
            {
              unitValues.mult1 = 1000;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 1: // W
            {
              unitValues.mult1 = 1;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 2: // HP
            {
              unitValues.mult1 = 735.5;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 3: // cal/s
            {
              unitValues.mult1 = 4.1868;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 4: // kcal/h
            {
              unitValues.mult1 = 1.163;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
        }
        break;
      }
    case 9 :  //volume
      {
        switch(unitIndex)
        {
          case 0: // m^3
            {
              unitValues.mult1 = 1;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 1: // dm^3
            {
              unitValues.mult1 = 0.001;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 2: // ft^3
            {
              unitValues.mult1 = 0.0283169;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 3: // in^3
            {
              unitValues.mult1 = 0.000016387;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 4: // UK gallon
            {
              unitValues.mult1 = 0.00454656;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
            case 5: // US gallon
              {
                unitValues.mult1 = 0.00378583;
                unitValues.mult2 = 0;
                unitValues.add1 = 0;
                unitValues.add2 = 0;
                break;
              }
        }
        break;
      }
    case 10 : //dynamicviscosity
      {
        switch(unitIndex)
        {
          case 0: // mPas or Cps (cP)
            {
              unitValues.mult1 = 0.001;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 1: // m^2/s
            {
              unitValues.mult1 = 1;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 2: // cSt
            {
              unitValues.mult1 = 0.000001;
              unitValues.mult2 = 0;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 3: // Second Saybolt Universal (SSU) - Saybolt
            {
              unitValues.mult1 = 0.00000021867;
              unitValues.mult2 = -0.00016586;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 4: // Seconds Redwood - Redwood
            {
              unitValues.mult1 = 0.00000024965;
              unitValues.mult2 = -0.00015399;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
          case 5: // °Engler
            {
              unitValues.mult1 = 0.0000077008;
              unitValues.mult2 = -0.0000073453;
              unitValues.add1 = 0;
              unitValues.add2 = 0;
              break;
            }
        }
        break;
      }
  }
  return unitValues;
};

export const getDisplayValue = (siValue, unitLabel, unitIndex, densityValueSI = 0) => {

  let displayValue = 0, result;

  var mult1, mult2, add1, add2;
  let unitValues = {mult1, mult2, add1, add2};

  unitValues = equivalentUnitValues(unitLabel, unitIndex);

  mult1 = unitValues.mult1;
  mult2 = unitValues.mult2;
  add1 = unitValues.add1;
  add2 = unitValues.add2;

  if(mult1 === 0)
  {
    result = mult2 / (siValue - add1) - add2;
  }
  else
  {
    if(mult2 === 0)
    {
      result = (siValue - add1) / mult1;
    }
    else
    {
      result = solveEquation(mult1, mult1 * add2 + add1 - siValue, mult2 + add1 * add2 - add2 * siValue);
    }
  }

  displayValue = result;

  //unitLabelEnum[7].label = "viscosity" and unitIndex[0] = mPas Or Cps
  if(unitLabel === unitLabelEnum[7].label && unitIndex === 0) 
  {
    if(densityValueSI < 0 || densityValueSI === 0)
    {
      displayValue = 0;
    }
    else
    {
      displayValue = displayValue * densityValueSI;
    }
  }

  //unitLabelEnum[10].label = "dynamicviscosity" and unitIndex[0] = mPas Or Cps
  if(unitLabel === unitLabelEnum[10].label && unitIndex !== 0) 
  {
    if(densityValueSI > 0)
    {
      displayValue = displayValue / densityValueSI;
    }
    else
    {
      displayValue = 0;
    }
  }

  displayValue = displayValue.toFixed(10);

  return displayValue;
};

export const unitIndexValueChange = (data) => {    //This Calculation has been moved from backend to frontend inorder to decrease the time lag.
  console.log("unitVc", data);
  let siValue = data.siValue,
  unitIndex = data.unitIndex,
  unitLabel = data.unitLabel,
  densityValueSI = data.densityValueSI;

  var value;
  let response = {unitLabel, value};
  let label, result;

  //This part written for pressure loss calculator screen. Because there are multiple pressure and length drop-downs. So for example: "inletpressure" is converted into "pressure" for calculation part
  label = unitLabel.toLowerCase().includes(unitLabelEnum[2].label) ? unitLabelEnum[2].label : (unitLabel.toLowerCase().includes(unitLabelEnum[3].label) ? unitLabelEnum[3].label : unitLabel);

  if(label === unitLabelEnum[7].label || label === unitLabelEnum[10].label)
  {
    result = getDisplayValue(siValue, label, unitIndex, densityValueSI);
  }
  else
  {
    result = getDisplayValue(siValue, label, unitIndex);
  }

  if(Math.round(result) > 0 && Math.abs(result - Math.round(result)) < 0.001 * Math.round(result))
  {
    response.value = Math.round(result);
  }
  else
  {
    response.value = fixDecimalPlaces(result,5);
  }
  console.log("unitVc response", response);
  return response;
};

export const getSiValue = (displayValue, unitLabel, unitIndex, densityValueSI = 0) => {
  let siValue = 0, result, temp, denominator;

  var mult1, mult2, add1, add2;
  let unitValues = {mult1, mult2, add1, add2};

  unitValues = equivalentUnitValues(unitLabel, unitIndex);

  mult1 = unitValues.mult1;
  mult2 = unitValues.mult2;
  add1 = unitValues.add1;
  add2 = unitValues.add2;

  denominator = displayValue + add2;

  if(denominator !== 0)
  {
    result = mult1 * displayValue + add1 + mult2 * 1 / denominator;
  }
  else
  {
    result = mult1 * displayValue + add1;
  }

  //unitLabelEnum[7].label = "viscosity" and unitIndex[0] = mPas Or Cps
  if(unitLabel === unitLabelEnum[7].label && unitIndex === 0)
  {
    if(densityValueSI > 0)
    {
      temp = result;
      result = temp / densityValueSI;
    }

    if(densityValueSI < 0 || densityValueSI === 0)
    {
      result = 0
    }
  }

  //unitLabelEnum[10].label = "viscosity" and unitIndex[0] = mPas Or Cps
  if(unitLabel === unitLabelEnum[10].label && unitIndex !== 0)
  {
    if(densityValueSI > 0)
    {
      temp = result;
      result = temp * densityValueSI;
    }

    if(densityValueSI < 0 || densityValueSI === 0)
    {
      result = 0
    }
  }

  siValue = result.toFixed(15);

  return siValue;
}

export const textValueChange = (data) => {    //This Calculation has been moved from backend to frontend inorder to decrease the time lag.
  console.log("textVC", data);
  let displayValue = data.displayValue,
  unitIndex = data.unitIndex,
  unitLabel = data.unitLabel,
  densityValueSI = data.densityValueSI;

  var value;
  let response = {unitLabel, value};
  let label;

  //This part written for pressure loss calculator screen. Because there are multiple pressure and length drop-downs. So for example: "inletpressure" is converted into "pressure" for calculation part
  label = unitLabel.toLowerCase().includes(unitLabelEnum[2].label) ? unitLabelEnum[2].label : (unitLabel.toLowerCase().includes(unitLabelEnum[3].label) ? unitLabelEnum[3].label : unitLabel);

  if(label === unitLabelEnum[7].label || label === unitLabelEnum[10].label)
  {
    response.value = getSiValue(displayValue, label, unitIndex, densityValueSI);
  }
  else
  {
    response.value = getSiValue(displayValue, label, unitIndex);
  }
  console.log("textVC response", response);
  return response;
};

export const siConversion = (displayValue, unitLabel, unitIndex, densityValue = 0) => {
  let siValue = 0;
  let result, denominator;

  var mult1, mult2, add1, add2;
  let unitValues = {mult1, mult2, add1, add2};

  unitValues = equivalentUnitValues(unitLabel, unitIndex);

  mult1 = unitValues.mult1;
  mult2 = unitValues.mult2;
  add1 = unitValues.add1;
  add2 = unitValues.add2;

  denominator = displayValue + add2;

  if(denominator !== 0)
  {
    result = mult1 * displayValue + add1 + mult2 * 1 / denominator;
  }
  else
  {
    result = mult1 * displayValue + add1;
  }

  //unitLabelEnum[7].label = "viscosity" and unitIndex[0] = mPas Or Cps
  if (unitLabel === unitLabelEnum[7].label && unitIndex === 0) 
  {
    result = result / densityValue;
  }

  siValue = result;

  return siValue;
};

export const siInvConversion = (siValue, unitLabel, unitIndex, densityValue = 0) => {
  let displayValue = 0;

  var mult1, mult2, add1, add2;
  let unitValues = {mult1, mult2, add1, add2};

  unitValues = equivalentUnitValues(unitLabel, unitIndex);

  mult1 = unitValues.mult1;
  mult2 = unitValues.mult2;
  add1 = unitValues.add1;
  add2 = unitValues.add2;

  if(mult1 === 0)
  {
    displayValue = mult2 / (siValue - add1) - add2;
  }
  else
  {
    if(mult2 === 0)
    {
      displayValue = (siValue - add1) / mult1;
    }
    else
    {
      displayValue = solveEquation(mult1, mult1 * add2 + add1 - siValue, mult2 + add1 * add2 - add2 * siValue);
    }
  }

  //unitLabelEnum[7].label = "viscosity" and unitIndex[0] = mPas Or Cps
  if(unitLabel === unitLabelEnum[7].label && unitIndex === 0) 
  {
    displayValue = displayValue * densityValue;
  }

  return displayValue;
};

export const unitValuesConverter = (data) => {
  
  let unitLabel = data.unitLabel,
      unitIndex = data.unitIndex,
      displayValue = data.displayValue,
      densityValue = data.densityValue;

  let lstValues = [];
  let unitValues = {unitLabel, lstValues};

  let siConv, unitsCount, siInvConv;

  if(unitLabel === unitLabelEnum[7].label && densityValue === null)
  {
    return 0;
  }

  densityValue = (unitLabel && unitLabel === unitLabelEnum[7].label) ? densityValue : 0;

  siConv = siConversion(displayValue, unitLabel, unitIndex, densityValue);

  unitLabelEnum.forEach((item) => {
    if(item.label === unitLabel)
    {
      unitsCount = item.count;
    }
  })

  for( let i = 0; i < unitsCount; i++)
  {
    siInvConv = siInvConversion(siConv, unitLabel, i, densityValue);

    siInvConv = siInvConv.toFixed(5);

    lstValues[i] = Number(siInvConv);
  }

  unitValues.lstValues = lstValues;
 
  return unitValues;
};

export const modifyDispalyValues = (data) => {

    let dataToSend, capacity, density, pressure, temperature, viscosity, result ;
    dataToSend = {
      siValue: Number(data.siValuesUnitIndex.liquidCapacitySI),
        unitIndex: Number(data.pSControlIndex.flow),
        unitLabel: "flow",
        densityValueSI: Number(data.siValuesUnitIndex.liquidDensitySI),
    }
    capacity = unitIndexValueChange(dataToSend);

    dataToSend = {
      siValue: Number(data.siValuesUnitIndex.liquidDensitySI),
        unitIndex: Number(data.pSControlIndex.density),
        unitLabel: "density",
        densityValueSI: Number(data.siValuesUnitIndex.liquidDensitySI),
    }
    density = unitIndexValueChange(dataToSend);

    dataToSend = {
      siValue: Number(data.siValuesUnitIndex.differentialPressureSI),
        unitIndex: Number(data.pSControlIndex.pressure),
        unitLabel: "pressure",
        densityValueSI: Number(data.siValuesUnitIndex.liquidDensitySI),
    }
    pressure = unitIndexValueChange(dataToSend);

    dataToSend = {
      siValue: Number(data.siValuesUnitIndex.maxTemperatureSI),
        unitIndex: Number(data.pSControlIndex.temperature),
        unitLabel: "temperature",
        densityValueSI: Number(data.siValuesUnitIndex.liquidDensitySI),
    }
    temperature = unitIndexValueChange(dataToSend);

    dataToSend = {
      siValue: Number(data.siValuesUnitIndex.liquidViscositySI),
        unitIndex: Number(data.pSControlIndex.dynamicviscosity),
        unitLabel: "dynamicviscosity",
        densityValueSI: Number(data.siValuesUnitIndex.liquidDensitySI),
    }
    viscosity = unitIndexValueChange(dataToSend);

    result = {
      ...data,
      displayValues:{
        liquidCapacity : Number(capacity.value),
        differentialPressure : Number(pressure.value),
        liquidDensity: Number(density.value),
        maxTemperature : Number(temperature.value),
        liquidViscosity : Number(viscosity.value)
      }
    }

    return result;
};

export const modifyDiffPressureValue = (data, isMetric) => {

  let dataToSend = {
    siValue: Number(data),
      unitIndex: isMetric === "us" ? 2 : 0,
      unitLabel: "cboDifferentialPressure",
  }
  
  let diff_pressure = unitIndexValueChange(dataToSend);
  return diff_pressure;
};

export const calculateDifferentialPressure = (data, isMetric) => {    //This Calculation has been moved from backend to frontend inorder to decrease the time lag.
      let StaticHeadInlet, StaticHeadOutlet, DiffPressure, DiffPressure1, unitVC, result;

          StaticHeadInlet = ComputeStaticHeadPressure(data.staticHeadInletSI, data.liquidDensitySI);
          StaticHeadOutlet = ComputeStaticHeadPressure(data.staticHeadOutletSI, data.liquidDensitySI);

          DiffPressure = Number(data.totalOutletPressureSI) + Number(data.outletPressureDropSI) + Number(StaticHeadOutlet);
          DiffPressure1 = DiffPressure - Number(data.totalInletPressureSI) + Number(data.inletPressureDropSI) - Number(StaticHeadInlet);
          
          unitVC = modifyDiffPressureValue(DiffPressure1, isMetric);

          result = {
            siValue: DiffPressure1,
            diff_pressure: unitVC.value,
          }  
      return result;
};

export const ComputeStaticHeadPressure = (HeadInMeter, LiquidDensity) => {

    let Result,  G = 9.80665;

    Result = fixDecimalPlaces((HeadInMeter * LiquidDensity * G), 10);

    return Result;
};

export const modifyAddElementsInlet = (data, densitySI, isMetric) => {
  let dataToSend = {
    siValue: Number(data.pipeLengthSI),
      unitIndex: isMetric === "us" ? 2 : 0,
      unitLabel: "inletPipeLength",
      densityValueSI: Number(densitySI),
  }
  let Length = unitIndexValueChange(dataToSend);

  dataToSend = {
    siValue: Number(data.pipeDiameterSI),
      unitIndex: isMetric === "us" ? 3: 1,
      unitLabel: "inletLengthDiameter",
      densityValueSI: Number(densitySI),
  }
  let diameter = unitIndexValueChange(dataToSend);

  let result = {
    ...data,
    inletPipeLength: Length.value,
    inletPipeDiameter: diameter.value,
  }

  return result;
};

export const modifyAddElementsOutlet = (data, densitySI, isMetric) => {
  let dataToSend = {
    siValue: Number(data.pipeLengthSI),
      unitIndex: isMetric === "us" ? 2 : 0,
      unitLabel: "outletPipeLength",
      densityValueSI: Number(densitySI),
  }
  let Length = unitIndexValueChange(dataToSend);

  dataToSend = {
    siValue: Number(data.pipeDiameterSI),
      unitIndex: isMetric === "us" ? 3 : 1,
      unitLabel: "outletLengthDiameter",
      densityValueSI: Number(densitySI),
  }
  let diameter = unitIndexValueChange(dataToSend);

  let result = {
    ...data,
    outletPipeLength: Length.value,
    outletPipeDiameter: diameter.value,
  }

  return result;
};

export const modifyCloseWindowValuesInlet = (data, plcFilterValues, isMetric) => {
  let dataToSend = {
    siValue: Number(data.pressureDropSI),
      unitIndex: isMetric ? 0 : 2,
      unitLabel: "inletPressure1",
      densityValueSI: Number(plcFilterValues.liquidDensitySI),
  }
  let pressureDrop = unitIndexValueChange(dataToSend);

  let dataToSend1 = {
    siValue: Number(data.dynamicPressureSI),
      unitIndex: isMetric ? 0 : 2,
      unitLabel: "inletPressure4",
      densityValueSI: Number(plcFilterValues.liquidDensitySI),
  }
  let dynamicPressure = unitIndexValueChange(dataToSend1);

  let totalPressureSI = (Number(plcFilterValues.staticInletPressureSI) + Number(data.dynamicPressureSI));
  let dataToSend2 = {
    siValue: Number(totalPressureSI),
      unitIndex: isMetric ? 0 : 2,
      unitLabel: "inletPressure5",
      densityValueSI: Number(plcFilterValues.liquidDensitySI),
  }
  let totalPressure = unitIndexValueChange(dataToSend2);

  let result = {
    ...plcFilterValues,
    inletPressureDrop: pressureDrop.value,
    inletPressureDropSI: data.pressureDropSI,
    inletPressure1: isMetric ? 0 : 2,                           // here the units in dropdown are changed to default units since the values are calculated to that unit
    dynamicInletPressure: dynamicPressure.value,
    dynamicInletPressureSI: data.dynamicPressureSI,
    inletPressure4: isMetric ? 0 : 2,
    totalPressureInlet: totalPressure.value,
    totalPressureInletSI: totalPressureSI,
    inletPressure5: isMetric ? 0 : 2,
  }
  return result;
};

export const modifyCloseWindowValuesOutlet = (data, plcFilterValues, isMetric) => {
  let dataToSend = {
    siValue: Number(data.pressureDropSI),
      unitIndex: isMetric ? 0 : 2,
      unitLabel: "outletPressure1",
      densityValueSI: Number(plcFilterValues.liquidDensitySI),
  }
  let pressureDrop = unitIndexValueChange(dataToSend);

  let dataToSend1 = {
    siValue: Number(data.dynamicPressureSI),
      unitIndex: isMetric ? 0 : 2,
      unitLabel: "outletPressure4",
      densityValueSI: Number(plcFilterValues.liquidDensitySI),
  }
  let dynamicPressure = unitIndexValueChange(dataToSend1);

  let totalPressureSI = (Number(plcFilterValues.staticOutletPressureSI) + Number(data.dynamicPressureSI));
  let dataToSend2 = {
    siValue: Number(totalPressureSI),
      unitIndex: isMetric ? 0 : 2,
      unitLabel: "outletPressure5",
      densityValueSI: Number(plcFilterValues.liquidDensitySI),
  }
  let totalPressure = unitIndexValueChange(dataToSend2);

  let result = {
    ...plcFilterValues,
    outletPressureDrop: pressureDrop.value,
    outletPressureDropSI: data.pressureDropSI,
    outletPressure1: isMetric ? 0 : 2,                          // here the units in dropdown are changed to default units since the values are calculated to that unit
    dynamicOutletPressure: dynamicPressure.value,
    dynamicOutletPressureSI: data.dynamicPressureSI,
    outletPressure4: isMetric ? 0 : 2,
    totalPressureOutlet: totalPressure.value,
    totalPressureOutletSI: totalPressureSI,
    outletPressure5: isMetric ? 0 : 2,
  }
  return result;
};

export const modifyComputePD = (data, isMetric) => {
  let result= [];
  for(let i = 0; i < data.length; i++)
  {
     let dataToSend = {
      siValue: Number(data[i].eqLengthSI),
      unitIndex: isMetric ? 0 : 2,
      unitLabel: "length",            // here densitySI is not a compulsory one, it is needed only when unitlabel = "viscosity" or "dynamicviscosity"
     }
     let eqLength = unitIndexValueChange(dataToSend);

     let dataToSend1 = {
      siValue: Number(data[i].pressureDropSI),
      unitIndex: isMetric ? 1 : 2,
      unitLabel: "pressure",
     }
     let pressure = unitIndexValueChange(dataToSend1);
     let velocity = isMetric ? (data[i].liquidVelocitySI) : (data[i].liquidVelocitySI * 3.28084);
     result[i] = {
      ...data[i],
      reynoldsNbr: fixDecimalPlaces(data[i].reynoldsNbr,4),
      lambda: fixDecimalPlaces(data[i].lambda,4),
      eqLength: fixDecimalPlaces(eqLength.value,4),
      pressureDrop: pressure.value,
      liquidVelocity: fixDecimalPlaces(velocity,4),
     }
  }
  return result;
};

export const pressureDropListVCLength = (label, index, response) => {
  let i = label.slice(-1);
  let dataToSend = {
    siValue: Number(response[i].eqLengthSI),
      unitIndex:  Number(index),
      unitLabel: "length",        // here densitySI is not a compulsory one, it is needed only when unitlabel = "viscosity" or "dynamicviscosity"
  }
  let result = unitIndexValueChange(dataToSend);

  response.forEach(data => {
    if(data.pipeNumber === label){
      data.eqLength = Number(result.value);
    }
  });
  return response;
};

export const pressureDropListVCPressure = (label, index, response) => {
  let i = label.slice(-1);
  let dataToSend = {
    siValue: Number(response[i].pressureDropSI),
      unitIndex:  Number(index),
      unitLabel: "pressure",           // here densitySI is not a compulsory one, it is needed only when unitlabel = "viscosity" or "dynamicviscosity"
  }
  let result = unitIndexValueChange(dataToSend);

  response.forEach(data => {
    if(data.pipeNumber === label){
      data.pressureDrop = Number(result.value);
    }
  });

  return response;
};

export const pressureDropListVCVelocity = (label, index, response) => {
  let i = label.slice(-1);
  let velocity;
  if(Number(index) === 1){
     velocity = Number(response[i].liquidVelocitySI) * 3.28084;
  }
  else {
     velocity = response[i].liquidVelocitySI;
  }

  response.forEach(data => {
    if(data.pipeNumber === label){
      data.liquidVelocity = Number(velocity);
    }
  });

  return response;
};

export const shearViscPointsModify = (data) => {
  let newArray = [];
  for(let i =0 ; i < data.length; i++){
    if((data[i].shearRate !== null) && (data[i].viscosity !== null)){
      newArray.push(data[i]);
    }
  }
  return newArray;
}

export const shearViscPointsUpdate = (data) => {
  console.log("shearVisc", data);
  let newArray = data;
  for(let i= data.length; i < 20; i++)
  {
     let test = {
      shearRate: null,
      viscosity: null
     }
     newArray[i] = test;
  }
  return newArray;
}
